// src/Zustand/services/testReportsService.ts
import axiosInstance from "Utils/axiosInstance";
import { base_url } from "Zustand/constants";
import { toast } from "react-toastify";

export type TestReportDTO = {
  nodeid: string;
  // keep it open-ended; backend may add props
  [k: string]: any;
};

export const getTestReportsByPlanAPI = async (testPlanNodeId: string) => {
  const url = `${base_url}/testreports?testPlanNodeId=${encodeURIComponent(
    testPlanNodeId
  )}`;
  const res = await axiosInstance.get(url);
  if (!res) throw new Error("Failed to fetch reports by testplannodeid");
  return res.data ? res.data[0] : [];
};

export async function getTestReportByNodeIdAPI(nodeid: string) {
  const encoded = encodeURIComponent(nodeid);
  const url = `${base_url}/testreports/${encoded}`;
  const res = await axiosInstance.get(url);
  if (!res) throw new Error(`Error Getting Test Report by nodeid: ${nodeid}`);
  return res.data ? res.data : [];
}

/**
 * PUT /api/v1/testrequirementreports
 * Send only changed fields (partial update).
 */
export async function updateTestRequirementReportAPI(
  payload: Partial<TestReportDTO> & { nodeid: string }
) {
  const url = `${base_url}/testrequirementreports`;
  const res = await axiosInstance.put(url, payload);
  if (!res) throw new Error(`updateTestRequirementReport failed`);
  return res.data;
}

/**
 * PUT /api/v1/testreports
 * Send only changed fields (partial update) — e.g. acceptancecriteria.
 */
export async function updateTestReportAPI(
  payload: Partial<TestReportDTO> & { nodeid: string }
) {
  const url = `${base_url}/testreports`;
  const res = await axiosInstance.put(url, payload);
  if (!res) throw new Error(`updateTestReport failed`);
  return res.data;
}

export async function getTdmsLogParametersAPI(nodeid: string) {
  const url = `${base_url}/testrequirementreports/${encodeURIComponent(
    nodeid
  )}/tdms/getlogparameters`;
  const res = await axiosInstance.post(url);
  if (!res) throw new Error("Failed to fetch TDMS log parameters");
  return res.data;
}

export const createTestReportAPI = async (testPlanNodeId: string) => {
  const payload = { testplannodeid: testPlanNodeId };
  const res = await axiosInstance.post(`${base_url}/testreports`, payload);
  if (res.status !== 200) throw new Error("Failed to create test report");

  toast.success("Test report created", {
    autoClose: 3000,
  });

  return res.data;
};
